(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ambra-header-account"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('[data-amb-hacct]') : null;
    if (!a) return;
    var drawer = document.getElementById('NavDrawer');
    var acc = drawer && drawer.querySelector('shopify-account');
    var dlg = acc && acc.shadowRoot && acc.shadowRoot.querySelector('dialog');
    if (!dlg) return;
    e.preventDefault();
    if (dlg.open) return;
    var wasInert = drawer.hasAttribute('inert');
    if (wasInert) {
      drawer.removeAttribute('inert');
      dlg.addEventListener('close', function () {
        if (!document.body.classList.contains('js-drawer-open-left')) drawer.setAttribute('inert', '');
      }, { once: true });
    }
    try { dlg.showModal(); } catch (err) { window.location.href = a.href; }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ambra-header-hide-on-scroll"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__ambHdrHideInit) return;
    window.__ambHdrHideInit = true;
    var mq = window.matchMedia('(max-width: 767px)');
    var THRESHOLD = 8;   /* px ruchu, zanim zmienimy stan — filtruje drgania */
    var TOP_ZONE = 120;  /* w tej strefie od góry nagłówek jest zawsze widoczny */
    var lastY = window.scrollY, hidden = false, ticking = false;

    function setHidden(v) {
      if (hidden === v) return;
      hidden = v;
      document.body.classList.toggle('amb-hdr-hide', v);
    }
    function update() {
      ticking = false;
      var phone = mq.matches;
      var desktopList = !phone && !!document.querySelector('[data-b2-root]');
      if (!phone && !desktopList) { setHidden(false); lastY = window.scrollY; return; }
      var top = phone ? TOP_ZONE : 300, back = phone ? THRESHOLD : 50;
      var y = window.scrollY, dy = y - lastY;
      var overlayOpen = /js-drawer-open|drawer-open|modal-open/.test(document.body.className) ||
        (desktopList && !!document.querySelector('.ais.is-open, .shopify-section-group-header-group:hover, .shopify-section-group-header-group:focus-within'));
      if (overlayOpen) { lastY = y; return; }
      if (y <= top) setHidden(false);
      else if (dy > THRESHOLD) setHidden(true);
      else if (dy < -back) setHidden(false);
      if (dy > THRESHOLD || dy < -back || y <= top) lastY = y;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('pageshow', function () { lastY = window.scrollY; setHidden(false); });
    if (mq.addEventListener) mq.addEventListener('change', function () { setHidden(false); lastY = window.scrollY; });
  })();
  } catch(e) { console.error(e); }
})();

})();
